import React, { Component, PropTypes } from 'react';
import { push, replace } from 'react-router-redux';
import { connect } from 'react-redux';

class SharedStoryStep1 extends Component {
  constructor(props) {
    super(props);
  }

  handleSubmit = () => {
    this.props.goToStep2();
  }

  render() {

    const auth = this.props.auth;
    const openAuthModal = this.props.openAuthModal;


    let ctaBtn = '';
    if (auth.user == null) {
      ctaBtn = <button onClick={openAuthModal} className="sharedStory-button submitButton button-primary">Log in or join to share your story!</button>
    } else {
      ctaBtn = <button onClick={this.handleSubmit} className="sharedStory-button submitButton button-primary">I'd like to share my story!</button>
    }


    return (
      <div className="sharedStory-step1Wrapper">
        <p>This new series highlights the stories and achievements of WorldWideWomen Members around the world. Our members come from over 80 countries and all walks of life, yet they are tied together by their dedication to creating gender equity in our global community.</p>
        <p>We invite you to join us and share your experiences and aspirations by responding to our questionnaire. The stories we choose will be featured on our website, in a weekly newsletter, and on our social media platforms. We will reach out to you if we plan to feature you!</p>

        <div className="sharedStory-btnWrapper">

          {ctaBtn}
        </div>

        <div className="sharedStory-pictWrapper">
          <div className="sharedStory-pictItem">
            <img src="images/shared_stories/www_photo01.jpg" />
          </div>
          <div className="sharedStory-pictItem">
            <img src="images/shared_stories/www_photo02.jpg" />
          </div>
          <div className="sharedStory-pictItem">
            <img src="images/shared_stories/www_photo03.jpg" />
          </div>
          <div className="sharedStory-pictItem">
            <img src="images/shared_stories/www_photo04.jpg" />
          </div>
        </div>

      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    replace
  }
)(SharedStoryStep1);



// WEBPACK FOOTER //
// ./src/components/sharedStory/SharedStoryStep1.jsx